// extracted by mini-css-extract-plugin
export default {"vedlegg":"G1L9ucDoB8QI4zzXZfDU","vedleggLink":"PuTDoQ1BCEc3uUpxCs7d","vedleggText":"_HXnGAJUUhRgCG9J0bAo","vedleggIcon":"i520pzH7xraoSnMoJVTu"};